/* eslint-disable camelcase */
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const TransactionTimeAndPlace = ({
  date, operator, register, store, time, timezone, transaction, customerDetails, suspendedTransactionReference
}) => {
  const {
    locale: { momentFormat, localeName }, Op, RL_Date, RL_Reg, RL_Store, RL_Time, RL_Tran,
  } = useSelector((state) => state);
  const customer = customerDetails?.[0];
  const customerAddress = customer?.Addresses?.[0];
  const stateCode = customer?.LocalRequirements?.[0]?.Value || '';
  const stateOrProvince = customerAddress?.StateOrProvince ? `${customerAddress.StateOrProvince}` : '';
  const AdditionalPlaceInfo = (
    <>
      <article className="justify-between">
        {/* <p>State: {address?.state}</p> */}
      </article>
      <article className="justify-between">
        <p>POS: {stateOrProvince}</p>
        <p>State Code: {stateCode}</p>
      </article>
      <br />
    </>
  );
  return (
    <>
      <article className="justify-between">
        <p>{RL_Store}: {store}</p><p>{Op}: {operator}</p>
      </article>
      <br />
      <article className="justify-between">
        <p>{RL_Date}: {date ? moment(date).format(momentFormat) : ''}</p><p>{RL_Time}: {time ? moment(time).tz(timezone).format('HH:mm:ss') : ''}</p>
      </article>
      <br />
      <article className="justify-between">
        <p>{RL_Reg}: {register}</p><p>{RL_Tran}: {transaction ?? ''}</p>
      </article>
      {localeName === 'el-GR' && suspendedTransactionReference && (
        <article className="justify-between">
          <p>ΑΝΑΣΤΟΛΗ ΟΝΟΜΑΤΟΣ : {suspendedTransactionReference}</p>
        </article>
      )}
      {localeName === 'en-IN' && AdditionalPlaceInfo}
      <br /><br />
    </>
  );
};

TransactionTimeAndPlace.defaultProps = {
  customerDetails: [],
  date: '',
  operator: '',
  register: '',
  store: '',
  suspendedTransactionReference: '',
  time: '',
  timezone: '',
  transaction: undefined,
};

TransactionTimeAndPlace.propTypes = {
  customerDetails: PropTypes.arrayOf(PropTypes.shape()),
  date: PropTypes.string,
  operator: PropTypes.string,
  register: PropTypes.string,
  store: PropTypes.string,
  suspendedTransactionReference: PropTypes.string,
  time: PropTypes.string,
  timezone: PropTypes.string,
  transaction: PropTypes.number,
};

export default TransactionTimeAndPlace;
